module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av547-9b8fd94656d49a8d2549bfb04ec6b646.jpg";